import {
  useDeleteFarmGateInternalTransportData,
  useGetFarmGateInternalTransportById,
  usePostFarmGateInternalTransportData,
  usePutFarmGateInternalTransportData
} from "../../../../../api/cultivations";
import {
  useDeleteSimulationFarmGateInternalTransportData,
  useGetSimulationFarmGateInternalTransportById,
  usePostSimulationFarmGateInternalTransportData,
  usePutSimulationFarmGateInternalTransportData
} from "../../../../../api/cultivations";
import {
  useDeleteProcessGateInternalTransportData,
  useGetProcessGateInternalTransportById,
  usePostProcessGateInternalTransportData,
  usePutProcessGateInternalTransportData
} from "../../../../../api/process";
import {
  useDeleteSimulationProcessGateInternalTransportData,
  useGetSimulationProcessGateInternalTransportById,
  usePostSimulationProcessGateInternalTransportData,
  usePutSimulationProcessGateInternalTransportData
} from "../../../../../api/simulation/process";
import {
  useDeleteFarmGateInternalTransportData as useDeleteSupplierFarmGateInternalTransportData,
  useGetFarmGateInternalTransportById as useGetSupplierFarmGateInternalTransportById,
  usePostFarmGateInternalTransportData as usePostSupplierFarmGateInternalTransportData,
  usePutFarmGateInternalTransportData as usePutSupplierFarmGateInternalTransportData
} from "../../../../../api/supplierFarmGate";
import {
  useDeleteProcessGateInternalTransportData as useDeleteSupplierProcessGateInternalTransportData,
  useGetProcessGateInternalTransportById as useGetSupplierProcessGateInternalTransportById,
  usePostProcessGateInternalTransportData as usePostSupplierProcessGateInternalTransportData,
  usePutProcessGateInternalTransportData as usePutSupplierProcessGateInternalTransportData
} from "../../../../../api/processGate/supplierProcess";
import { InternalTransportGate, InternalTransportToolVariant } from "./internalTransport.types";

type InternalTransportApiHookSet = {
  useGetById: (id: string | null) => {
    data: any;
    status: string;
    fetchStatus: string;
  };
  usePost: () => { mutate: (...args: any[]) => void; isLoading: boolean };
  usePut: () => { mutate: (...args: any[]) => void; isLoading: boolean };
  useDelete: () => { mutate: (...args: any[]) => void };
  useGetOriginalById: (id: string | null) => { data: any };
};

export const INTERNAL_TRANSPORT_API_HOOKS: Record<
  InternalTransportGate,
  Record<InternalTransportToolVariant, InternalTransportApiHookSet>
> = {
  farm: {
    mapping: {
      useGetById: useGetFarmGateInternalTransportById,
      usePost: usePostFarmGateInternalTransportData,
      usePut: usePutFarmGateInternalTransportData,
      useDelete: useDeleteFarmGateInternalTransportData,
      useGetOriginalById: useGetFarmGateInternalTransportById
    },
    simulate: {
      useGetById: useGetSimulationFarmGateInternalTransportById,
      usePost: usePostSimulationFarmGateInternalTransportData,
      usePut: usePutSimulationFarmGateInternalTransportData,
      useDelete: useDeleteSimulationFarmGateInternalTransportData,
      useGetOriginalById: useGetFarmGateInternalTransportById
    },
    supplier: {
      useGetById: useGetSupplierFarmGateInternalTransportById,
      usePost: usePostSupplierFarmGateInternalTransportData,
      usePut: usePutSupplierFarmGateInternalTransportData,
      useDelete: useDeleteSupplierFarmGateInternalTransportData,
      useGetOriginalById: useGetSupplierFarmGateInternalTransportById
    }
  },
  process: {
    mapping: {
      useGetById: useGetProcessGateInternalTransportById,
      usePost: usePostProcessGateInternalTransportData,
      usePut: usePutProcessGateInternalTransportData,
      useDelete: useDeleteProcessGateInternalTransportData,
      useGetOriginalById: useGetProcessGateInternalTransportById
    },
    simulate: {
      useGetById: useGetSimulationProcessGateInternalTransportById,
      usePost: usePostSimulationProcessGateInternalTransportData,
      usePut: usePutSimulationProcessGateInternalTransportData,
      useDelete: useDeleteSimulationProcessGateInternalTransportData,
      useGetOriginalById: useGetProcessGateInternalTransportById
    },
    supplier: {
      useGetById: useGetSupplierProcessGateInternalTransportById,
      usePost: usePostSupplierProcessGateInternalTransportData,
      usePut: usePutSupplierProcessGateInternalTransportData,
      useDelete: useDeleteSupplierProcessGateInternalTransportData,
      useGetOriginalById: useGetSupplierProcessGateInternalTransportById
    }
  }
};

export const getInternalTransportApiHooks = (
  gate: InternalTransportGate,
  variant: InternalTransportToolVariant
): InternalTransportApiHookSet => INTERNAL_TRANSPORT_API_HOOKS[gate][variant];
